import './Fab.css';

import { FC } from 'react';

import { concatStringish } from '../../utils/strings/concatStringish';
import { ButtonProps, Buttons, FlatButton } from './FlatButton';

const FabVariants = {
  small: 'Fab--small',
};

type FabVariantType = keyof typeof FabVariants;

export const Fab: FC<
  ButtonProps & {
    'aria-label': string;
    noHover?: boolean;
    variants?: FabVariantType[];
  }
> = ({ children, className, noHover, variants, ...props }) => {
  const variantClassNames = variants?.map((variant) => FabVariants[variant]);
  const newClassName = concatStringish(
    Buttons.Fab,
    className,
    ...(variantClassNames ?? []),
    noHover ? 'noHover' : undefined,
  );
  return (
    <FlatButton type="button" {...props} className={newClassName} variant={Buttons.Fab}>
      {children}
    </FlatButton>
  );
};
